// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"organizationSingle_mainContent__27to-","content":"organizationSingle_content__1xDwb","links":"organizationSingle_links__249iq"};